"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = require("./types");
var initialState = {
    name: ''
};
function nameReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case types_1.SET_NAME_VALUE:
            return {
                name: action.payload.name
            };
        case types_1.RESET_NAME_VALUE:
            return initialState;
        default:
            return state;
    }
}
exports.nameReducer = nameReducer;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/store/name/reducers.ts
// module id = 2415
// module chunks = 5